import React from "react";
import Col from "react-bootstrap/lib/Col";
import { Field, Form, withFormik } from "formik";

import { connect } from "react-redux";
import { compose } from "redux";
import Container from "pages/_components/Container";
import Button from "pages/_components/Button";
import DateField from "pages/_components/fields/DateField";
import * as Yup from "yup";
import * as i18n from "util/i18n";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import moment from "moment";
import { isIOS } from "react-device-detect";

const FORM_ID = "date.filter";

const HistoricalBalancesFilter = () => {
    const maxDate = moment().add(-1, "day");

    return (
        <Form>
            <Container
                className={
                    isIOS ? "container--layout align-items-center mb-0 pb-0" : "container--layout align-items-center"
                }
                gridClassName="form-content">
                <Col sm={12} md={4} className="col col-12 col-no-pad-mobile">
                    <div className="form-group">
                        <Field
                            component={DateField}
                            hidePlaceholder
                            label="Fecha"
                            idForm={FORM_ID}
                            name="date"
                            maxDate={maxDate}
                            minDate={null}
                            noEdit
                        />
                    </div>
                </Col>
                <Col
                    sm={12}
                    md={4}
                    className="col col-no-pad-mobile"
                    style={{
                        alignSelf: "flex-start",
                    }}>
                    <div className="form-group">
                        <div className={isIOS ? "form-group" : "form-group mt-8"}>
                            <div className="button-group">
                                <Button bsStyle="primary" label="forms.bankselector.search" type="submit" />
                            </div>
                        </div>
                    </div>
                </Col>
            </Container>
        </Form>
    );
};

const mapStateToProps = (state) => ({
    historicalBalances: accountsSelectors.getHistoricalBalances(state),
    date: accountsSelectors.getDate(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: true,
        mapPropsToValues: ({ date }) => ({
            date,
        }),
        validationSchema: () =>
            Yup.object().shape({
                date: Yup.string()
                    .test("past", "Fecha invalida", (val) => new Date(val).getTime() < new Date().setHours(0, 0, 0, 0))
                    .required(i18n.get("deposits.request.required"))
                    .nullable(),
            }),
        handleSubmit: (date, formikBag) => {
            const { dispatch } = formikBag.props;
            const formattedDate = date.date.toISOString().split("T")[0];
            dispatch(accountsActions.historicalBalances(formikBag.props.account.idProduct, formattedDate));
        },
    }),
)(HistoricalBalancesFilter);
